/** The droppable id of an empty day's slot. Event rows are numbers, so the two can't collide. */
export const daySlotId = (dayIndex: number): string => `day-${dayIndex}`

/** The Trip day a droppable id names, when it is a day's empty slot. */
export const dayOfSlotId = (id: string | number): number | null => {
	const match = typeof id === 'string' ? id.match(/^day-(\d+)$/) : null
	return match ? Number(match[1]) : null
}
